import 'slick-carousel';
const childrens = window.childrens;
export default {
  init() {

    $('.gallery-post').on('click', function () {
      let galleryId = $(this).data('id');

      jQuery.ajax({
        type: 'POST',
        url: childrens.ajax_url,
        data: { action: 'gallery_filter', galleryId: galleryId},
        success: function(response) {
          $('#gallery-modal .modal-body').html(response);
          $('.gallery-nav .gallery-image:first-child').addClass('blue-filter');
          $('.gallery-for').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            nextArrow: $('.slick-gallery-next'),
            prevArrow: $('.slick-gallery-prev'),
            fade: true,
          });


          $('.gallery-for').on('afterChange', function (event, slick, currentSlide){
            let dataNav = $('.gallery-nav .gallery-image[data-thumb="'+currentSlide+'"]');
            $('.gallery-nav .gallery-image').removeClass('blue-filter');
            dataNav.addClass('blue-filter');
          });

          $('.gallery-nav .gallery-image').on('click', function(){
            $('.gallery-for').slick('slickGoTo', $(this).data('thumb'));
          });

        },
      });
    });


  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateGallery.js